import BenchlingConfig from 'BenchlingConfig';
import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {assertNever} from 'util/Types';

export function isAISidepanelEnabled(): boolean {
  return Object.values(ChatType).some((chatType) => isChatTypeEnabled(chatType));
}

export function getChatTypes(): Array<ChatType> {
  return Object.values(ChatType).filter((chatType) => isChatTypeEnabled(chatType));
}

export function isChatTypeEnabled(chatType: ChatType): boolean {
  switch (chatType) {
    case ChatType.DEEP_RESEARCH:
      return BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH;
    case ChatType.DATA_CAPTURE:
      return BenchlingConfig.LLM_ENABLE_AI_DATA_CAPTURE_ASSISTANT;
    default:
      return false;
  }
}

export function getChatTypeText(chatType: ChatType): string {
  switch (chatType) {
    case ChatType.DEEP_RESEARCH:
      return 'deep research';
    case ChatType.DATA_CAPTURE:
      return 'data capture';
    default:
      throw new Error(`Unknown chat type: ${assertNever(chatType)}`);
  }
}
